import { uploadAvatar, uploadFile, uploadNftFile } from 'APIs/utils';
import { SetStateAction } from 'react';

export interface VideoUrls {
  image: string;
  video: string;
  audio: string;
}
export const uploadFileUtil = async (
  file: File,
  setProgress?: SetStateAction<any>,
  watermark?: boolean,
  avatar?: boolean,
  nftId?: number,
  backstageWatermark?: boolean
): Promise<string> => {
  const formDataIns = new FormData();
  let fileUrl: string;
  formDataIns.append('file', file);
  if (!avatar)
    fileUrl = await uploadFile(
      formDataIns,
      setProgress,
      watermark,
      nftId,
      backstageWatermark
    );
  else fileUrl = await uploadAvatar(formDataIns);
  if (fileUrl) {
    return fileUrl;
  }
  return '';
};

export const uploadNftFileUtil = async (
  file: File,
  setProgress?: SetStateAction<any>,
  watermark?: boolean,
  nftId?: number,
  backstageWatermark?: boolean
): Promise<VideoUrls> => {
  const formDataIns = new FormData();
  let fileUrl: VideoUrls;
  formDataIns.append('file', file);
  fileUrl = await uploadNftFile(
    formDataIns,
    setProgress,
    watermark,
    nftId,
    backstageWatermark
  );

  return fileUrl;
};

// export const uploadOtrFileUtil = async (
//   file: File,
//   setProgress?: SetStateAction<any>,
//   avatar?: boolean
// ): Promise<any> => {
//   const formDataIns = new FormData();
//   let fileUrl: string;
//   formDataIns.append('file', file);
//   if (!avatar) fileUrl = await uploadFile(formDataIns, setProgress);
//   else fileUrl = await uploadAvatar(formDataIns);
//   if (fileUrl) {
//     return fileUrl;
//   }
//   return '';
// };
